import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import ErrorBoundary from "./components/error-boundary";

interface RouterContext {
  authorized: boolean;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  errorComponent: RouteErrorFallback,
});

function RootComponent() {
  return (
    <ErrorBoundary>
      <Outlet />
      {/* {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />} */}
    </ErrorBoundary>
  );
}

function RouteErrorFallback() {
  return <p>Loading failed! Please reload.</p>;
}

